import React from "react";
import { useParams } from "react-router-dom";
import { DashboardLayout } from "../../../components/layouts/DashboardLayout";
import { Box, Card } from "@mantine/core";
import { PageProps } from "@sdflc/react-router-pages";
import { VenueDisplayList } from "../../../components/features/Venues/VenueDisplayList";
import { DisplayLinkError } from "../../../components/features/DisplayActivations/DisplayLinkError";

export const DisplayLinkPage: React.FC<PageProps> = (props: PageProps) => {
  const { activationCode } = useParams<{ activationCode: string }>();

  return (
    <DashboardLayout {...props}>
      <Box>
        <Card shadow="sm" padding="lg" radius="md" withBorder>
          {!activationCode ? (
            <DisplayLinkError
              title="No Activation Code"
              message="No activation code was provided in the URL. Please check the link and try again."
            />
          ) : (
            <VenueDisplayList activationCode={activationCode} />
          )}
        </Card>
      </Box>
    </DashboardLayout>
  );
};
